import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChild,
    ElementRef,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContextBarService } from '../context-bar.service';

/**
 * Context Bar Component.
 */
@Component({
    selector: 'pay-context-bar-dynamic-placeholder',
    template: `
        <ng-container
            *ngTemplateOutlet="
                dynamicTemplate;
                context: { data: dynamicPortalData }
            "
        ></ng-container>
    `,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class ContextBarDynamicPlaceholderComponent
    implements OnInit, OnDestroy {
    @ContentChild(TemplateRef, { static: false }) dynamicTemplate;

    public dynamicPortalData: any;
    public dynamicPortalCssClass: string = '';

    private nativeElement: HTMLElement;
    private destroyed$: Subject<void> = new Subject();

    constructor(
        private contextBarService: ContextBarService,
        private viewContainerRef: ViewContainerRef,
        private element: ElementRef,
        private cdr: ChangeDetectorRef
    ) {
        this.nativeElement = element.nativeElement;
    }

    ngOnInit() {
        this.contextBarService
            .getDynamicActionsContents()
            .pipe(takeUntil(this.destroyed$))
            .subscribe(
                (contents: {
                    templateRef: TemplateRef<unknown>;
                    data: any;
                    cssClass: string;
                }) => {
                    this.dynamicTemplate = contents?.templateRef || null;
                    this.dynamicPortalData = contents?.data || null;

                    if (contents?.cssClass?.length) {
                        this.nativeElement.classList.add(contents?.cssClass);
                    }

                    this.cdr.detectChanges();
                }
            );
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.viewContainerRef.clear();
    }
}
